import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	getAdminDetail,
	getAdminUsers,
	sendReminder,
	setAdminDigest,
} from "../../api/commands/admin";
import { Dialog } from "../../widgets/dialog";

export const Message = defineMessageUnion({
	CompletedFetchUsers: { generation: S.Number, result: getAdminUsers.Result },
	ChangedSearch: { search: S.String },
	ClickedUser: { circleId: S.String },
	CompletedFetchDetail: {
		circleId: S.String,
		generation: S.Number,
		result: getAdminDetail.Result,
	},
	ClickedSendReminder: {},
	ClickedConfirmSend: {},
	CompletedSendReminder: {
		circleId: S.String,
		email: S.String,
		generation: S.Number,
		result: sendReminder.Result,
	},
	ToggledDigest: { email: S.String, subscribed: S.Boolean },
	CompletedSetDigest: {
		email: S.String,
		subscribed: S.Boolean,
		generation: S.Number,
		result: setAdminDigest.Result,
	},
	ClickedCopyEmail: {},
	CopyFeedbackExpired: {},
	GotDialogMessage: { message: Dialog.Message },
});
export type Message = typeof Message.Type;
